export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Start of the next full hour from now (e.g. 16:25 → 17:00). */
export function getStartOfNextHour(now: Date = new Date()): Date {
  const next = new Date(now);
  next.setMinutes(0, 0, 0);
  next.setHours(next.getHours() + 1);
  return next;
}

/**
 * When the selected booking date is today, hide slots that start before the next full hour.
 */
export function filterPastSlotsForToday<T extends { start: string }>(
  slots: T[],
  selectedDate: string,
  now: Date = new Date(),
): T[] {
  if (!selectedDate || selectedDate !== formatLocalDate(now)) {
    return slots;
  }

  const minStart = getStartOfNextHour(now);
  return slots.filter((slot) => new Date(slot.start) >= minStart);
}
